import { mapState, mapGetters, mapActions } from 'vuex'

export const appAuthComputed = {
  ...mapState('appAuth', {
    appSession: (state) => state.appSession,
  }),
  ...mapGetters('appAuth', ['appLoggedIn', 'updateCompanyInfo']),
}

export const appAuthMethods = mapActions('appAuth', [
  'appLogIn',
  'companyInfoExists',
])

export const authComputed = {
  ...mapState('auth', {
    currentSession: (state) => state.currentSession,
    userRole: (state) => {
      let userRole = 'No especificado'
      const session = state.currentSession
      if (session.user.groups.length) {
        userRole = session.user.groups_detail[0].name
      }
      return userRole
    },
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'register',
  'resetPassword',
  'setUserActiveSection',
  'logInTwoFactor',
  'forgotPasswordAction',
  'resetPasswordAction',
])

export const twoFactorAuthMethods = mapActions('twoFactorAuth', [
  'sendEmailAuth',
  'fetchQR',
  'activateTotpAuth',
  'activateEmailAuth',
  'fetchAuthDevices',
  'deleteTotpAuth',
  'deleteEmailAuth',
])

export const languageComputed = {
  ...mapState('language', {
    language: (state) => state.language,
  }),
}

export const languageMethods = mapActions('language', ['setLanguage'])

export const usersComputed = {
  ...mapState('management/users', {
    cached: (state) => state.cached,
  }),
}

export const usersMethods = mapActions('management/users', [
  'fetchUsers',
  'createUpdateUsers',
  'deleteUsers',
  'changePassword',
  'updatePhotos',
  'fetchUsersDetail',
  'fetchUsersForOptions',
  'fetchUsersOptions',
  'checkIfUserExists',
  'registerUsers',
  'registerRedUsers',
  'changeFirstLoginAction',
  'fetchCoordinatorsOptions',
  'fetchCoordinators',
  'addStakeHolderToUser',
  'removeStakeHolderToUser',
  'fetchUserInfo',
  'changeFirstLoginRed'
])

export const permsComputed = {
  ...mapState('management/perms', {
    cached: (state) => state.cached,
  }),
}

export const permsMethods = mapActions('management/perms', [
  'fetchPerms',
  'createUpdatePerms',
  'deletePerms',
  'fetchPermsDetail',
])

export const groupsComputed = {
  ...mapState('management/groups', {
    cached: (state) => state.cached,
  }),
}

export const groupsMethods = mapActions('management/groups', [
  'fetchGroups',
  'createUpdateGroups',
  'deleteGroups',
  'fetchGroupsDetail',
])

export const appSectionsComputed = {
  ...mapState('management/appSections', {
    cached: (state) => state.cached,
  }),
}

export const appSectionsMethods = mapActions('management/appSections', [
  'fetchAppSections',
  'createUpdateAppSections',
  'deleteAppSections',
  'fetchAppSectionsDetail',
])

export const companyInfoComputed = {
  ...mapState('management/companyInfo', {
    cached: (state) => state.cached,
  }),
}

export const companyInfoMethods = mapActions('management/companyInfo', [
  'fetchCompanyInfo',
  'createUpdateCompanyInfo',
  'setFileCompanyInfo',
])

// Periodic tasks helpers
export const periodicTasksMethods = mapActions('periodicTasks', [
  'fetchPeriodicTasks',
  'createUpdatePeriodicTasks',
  'deletePeriodicTasks',
  'fetchPeriodicTasksDetail',
  'fetchPeriodicTasksOptions',
  'getLiveResultsPeriodicTasks',
  'executeManuallyPeriodicTasks',
])

export const periodicTasksResultsMethods = mapActions('periodicTasksResults', [
  'fetchPeriodicTasksResults',
  'createUpdatePeriodicTasksResults',
  'deletePeriodicTasksResults',
  'fetchPeriodicTasksResultsDetail',
])

export const periodicTasksSolarScheduleMethods = mapActions(
  'periodicTasksSolarSchedule',
  [
    'fetchPeriodicTasksSolarSchedule',
    'createUpdatePeriodicTasksSolarSchedule',
    'deletePeriodicTasksSolarSchedule',
    'fetchPeriodicTasksSolarScheduleDetail',
  ]
)

// export const navTabLandingComputed = {
//   ...mapState('navTab', {
//     tabIndex: (state) => state.tabIndex,
//   }),
//   ...mapGetters('navTab', ['getTabIndex']),
// }

// export const navTabLandingMethods = mapActions(
//   'navTab',['setTabIndex']
// )


export const periodicTasksIntervalScheduleMethods = mapActions(
  'periodicTasksIntervalSchedule',
  [
    'fetchPeriodicTasksIntervalSchedule',
    'createUpdatePeriodicTasksIntervalSchedule',
    'deletePeriodicTasksIntervalSchedule',
    'fetchPeriodicTasksIntervalScheduleDetail',
  ]
)

export const periodicTasksClockedScheduleMethods = mapActions(
  'periodicTasksClockedSchedule',
  [
    'fetchPeriodicTasksClockedSchedule',
    'createUpdatePeriodicTasksClockedSchedule',
    'deletePeriodicTasksClockedSchedule',
    'fetchPeriodicTasksClockedScheduleDetail',
  ]
)

export const periodicTasksCrontabScheduleMethods = mapActions(
  'periodicTasksCrontabSchedule',
  [
    'fetchPeriodicTasksCrontabSchedule',
    'createUpdatePeriodicTasksCrontabSchedule',
    'deletePeriodicTasksCrontabSchedule',
    'fetchPeriodicTasksCrontabScheduleDetail',
  ]
)

// MANAGEMENT/MASTERS:

export const managementMastersTerritoriesMethods = mapActions(
  'management/masters/territories',
  [
    'fetchTerritories',
    'createTerritories',
    'updateTerritories',
    'deleteTerritories',
  ]
)

export const managementMastersTerritoriesComputed = {
  ...mapGetters('management/masters/territories', ['getTerritoryFields']),
}

export const managementMastersSourcesMethods = mapActions(
  'management/masters/sources',
  ['fetchSources', 'createSources', 'updateSources', 'deleteSources']
)

export const managementMastersSourcesComputed = {
  ...mapGetters('management/masters/sources', ['getSourceFields']),
}

export const managementMastersLinesMethods = mapActions(
  'management/masters/lines',
  ['fetchLines', 'createLines', 'updateLines', 'deleteLines', 'fetchLinesOptions']
)

export const managementMastersLinesComputed = {
  ...mapGetters('management/masters/lines', ['getLineFields']),
}

export const managementMastersProjectsMethods = mapActions(
  'management/masters/projects',
  [
    'fetchProjects',
    'createProjects',
    'updateProjects',
    'deleteProjects',
    'fetchProjectsOptions',
    'fetchProjectsActivityOptions',
    'fetchProjectsActivity',
    'fetchProjectsActivityScheduleId',
    'fetchProjectsActivitySchedule'
  ]
)
export const managementMastersProjectsComputed = {
  ...mapGetters('management/masters/projects', ['getProjectFields']),
}

export const managementMastersActivitiesMethods = mapActions(
  'management/masters/activities',
  [
    'fetchActivities',
    'createActivities',
    'fetchActivitiesOptions',
    'updateActivities',
    'deleteActivities',
  ]
)
export const managementMastersActivitiesComputed = {
  ...mapGetters('management/masters/activities', ['getActivityFields']),
}

export const managementMastersRequirementsMethods = mapActions(
  'management/masters/requirements',
  [
    'fetchRequirements',
    'createRequirements',
    'updateRequirements',
    'deleteRequirements',
  ]
)
export const managementMastersRequirementsComputed = {
  ...mapGetters('management/masters/requirements', [
    'getActivitySubtaskFields',
  ]),
}

export const managementMastersDepartmentsComputed = {
  ...mapGetters('management/masters/departments', ['getDepartmentFields']),
}
export const managementMastersDepartmentsMethods = mapActions(
  'management/masters/departments',
  [
    'fetchDepartments',
    'createDepartments',
    'updateDepartments',
    'deleteDepartments',
  ]
)

export const managementMastersMunicipalitiesComputed = {
  ...mapGetters('management/masters/municipalities', ['getMunicipalityFields']),
}
export const managementMastersMunicipalitiesMethods = mapActions(
  'management/masters/municipalities',
  [
    'fetchMunicipalities',
    'createMunicipalities',
    'updateMunicipalities',
    'deleteMunicipalities',
    'fetchMunicipalitiesByTerritory',
  ]
)

export const managementMastersBanksComputed = {
  ...mapGetters('management/masters/banks', ['getBankFields']),
}
export const managementMastersBanksMethods = mapActions(
  'management/masters/banks',
  ['fetchBanks', 'createBanks', 'updateBanks', 'deleteBanks']
)

export const managementMastersCategoriesComputed = {
  ...mapGetters('management/masters/categories', ['getCategoryFields']),
}
export const managementMastersTematicsComputed = {
  ...mapGetters('management/masters/tematics', ['getTematicFields']),
}
export const managementMastersCategoriesMethods = mapActions(
  'management/masters/categories',
  [
    'fetchCategories',
    'createCategories',
    'updateCategories',
    'deleteCategories',
    'fetchCategoriesFilter'
  ]
)

export const managementMastersTematicsMethods = mapActions(
  'management/masters/tematics',
  [
    'fetchTematics',
    'createTematics',
    'updateTematics',
    'deleteTematics',
    'fetchTematicsFilter'
  ]
)
export const managementForosMethods = mapActions(
  'forum/forum',
  [
    'fetchForos',
    'createUpdateForo',
    'createForoFile',
    'createForoPhoto',
    'createForoComment',
    'createForoCommentResponse',
    'changeForoState',
    'changeForoRelease',
    'getForoFile',
    'fetchForumsLanding',
    'fetchCategoriesForumsLanding',
    'fetchStakeHoldersForumsLanding'
  ]
)
export const managementMinutasMethods = mapActions(
  'minutas/minutas',
  [
    'createMinutaAccionTutela',
    'createMinutaDerechoPeticion',
    'createMinutaSolicitudCertificado',
    'createMinutaPresentacionPersoneria',
    'createMinutaActaConstitucion',
  ]
)

export const managementMastersSubcategoriesComputed = {
  ...mapGetters('management/masters/subcategories', ['getSubcategoryFields']),
}
export const managementMastersSubcategoriesMethods = mapActions(
  'management/masters/subcategories',
  [
    'fetchSubcategories',
    'createSubcategories',
    'updateSubcategories',
    'deleteSubcategories',
  ]
)

export const managementMastersReferencesComputed = {
  ...mapGetters('management/masters/references', ['getReferenceFields']),
}
export const managementMastersReferencesMethods = mapActions(
  'management/masters/references',
  [
    'fetchReferences',
    'createReferences',
    'updateReferences',
    'deleteReferences',
    'fetchReferencesOptions',
  ]
)
export const managementMastersStakeholdersComputed = {
  ...mapGetters('management/masters/stakeholders', ['getStakeholderFields']),
}
export const managementMastersStakeholdersMethods = mapActions(
  'management/masters/stakeholders',
  [
    'fetchStakeholders',
    'createStakeholders',
    'updateStakeholders',
    'deleteStakeholders',
  ]
)

export const managementMastersRepositoriesComputed = {
  ...mapGetters('management/masters/repositories', ['getRepositoryFields']),
}
export const managementMastersRepositoriesMethods = mapActions(
  'management/masters/repositories', ['fetchRepositories', 'createRepositories',
  'updateRepositories', 'deleteRepositories', 'fetchRepositoriesOptions'])

export const managementMastersFilesComputed = {
  ...mapGetters('management/masters/files', ['getFileFields']),
}
export const managementMastersFilesMethods = mapActions(
  'management/masters/files', ['fetchFiles', 'createFiles',
  'updateFiles', 'deleteFiles'])

export const managementMastersFieldsComputed = {
  ...mapGetters('management/masters/fields', ['getFieldFields']),
}
export const managementMastersFieldsMethods = mapActions(
  'management/masters/fields', ['fetchFields', 'createFields',
  'updateFields', 'deleteFields'])

export const publicationsContentMethods = mapActions(
  'content/publications', ['fetchPublications', 'fetchPublicationsHome', 'fetchPublicationsDocument', 'fetchSelfPublications', 'createUpdatePublication', 'fetchPublication', 'changePublicationState',
  'deletePublication', 'fetchPublicationDetail', 'fetchPublicationsForRed', 'fetchPublicationsDocumentMunicipalities', 'fetchPublicationsDocumentCategories',
  'fetchPublicationOptions', 'fetchPublicationFiles', 'deletePublicationFile', 'createPublicationFile', 'getPublicationFile',
  'fetchPublicationsDocumentClassifications', 'fetchPublicationsDocumentReferences', 'changePublicationActive', 'fetchPublicationsDocumentAuthors']
)

export const coursesContentMethods = mapActions(
  'content/courses', ['fetchCourses', 'fetchCoursesHome', 'fetchSelfCourses', 'createUpdateCourse', 'fetchCourse', 'changeCourseState',
  'deleteCourse', 'fetchCourseDetail', 'fetchCourseOptions', 'fetchCourseFiles', 'deleteCourseFile', 'createCourseFile', 'getCourseFile']
)
export const projectsSchedulingMethods = mapActions(
  'projects/scheduling', ['fetchScheduling', 'fetchSelfScheduling', 'createUpdateSchedule', 'fetchScheduleReport',
  'deleteSchedule', 'fetchScheduleDetail', 'fetchScheduleOptions', 'fetchAdvisersScheduling',
  'fetchSchedulingResou<rceRequests', 'createUpdateSchedulingResourceRequests',
  'fetchSchedulingResourceDetail', 'fetchAccounts', 'fetchAdminScheduling', 'fetchSchedulingCompleteAll',
  'fetchSchedulingCompleteAllMe', 'fetchSchedulingCompleteAllAdvisers', 'fetchSchedulingCompleteAllAdmin', 'fetchSchedulingProject',
  //Attendance
  'fetchAttendance', 'createAttendance',
  // Survey
  'fetchScheduleSurvey', 'createUpdateScheduleSurvey', 'fetchSchedulingIGuest', 'fetchSchedulingResourceRequests',
  //Files 
  'fetchScheduleFiles', 'deleteScheduleFile', 'fetchSchedulingCompleteCounting',
])

export const projectsRequestsMethods = mapActions('projects/requests', [
  'fetchRequests',
  'fetchRequestsContabilidad',
  'createUpdateRequest',
  'actionRequest',
  'deleteRequest',
  'fetchRequestDetail',
  'fetchRequestProjects',
  'fetchRequestOptions',
  'fetchRequestResourcesOverview',
  'fetchRequestResourcesLegalization',
  'putRequestResourcesLegalization',
  //Files Methods
  'fetchRequestFiles',
  'deleteRequestFile',
  'againRequest',
  'reportRequest',
  'fetchRequestScheduleFiles'
])

export const projectsAccountsMethods = mapActions('projects/accounts', [
  'fetchAccounts',
  'createUpdateAccount',
])

export const projectsLegalizationsMethods = mapActions(
  'projects/legalizations',
  [
    'fetchLegalizationsAllData',
    'fetchEditLegalizationQuantity',
    'fetchCreateLegalizations',
    'fetchActivityHaveLegalization',
    'fetchProjectLegalization'
  ]
)

export const projectsProvidersMethods = mapActions('projects/providers', [
  'fetchProviders',
  'createUpdateProvider',
])

export const participantsMethods = mapActions('projects/participants', [
  'fetchParticipants',
  'createUpdateParticipants',
  'fetchParticipantByIdentification',
  'deleteParticipants',
  'fetchParticipantsDetail',
])

export const reportParticipantsMethods = mapActions(
  'projects/reportParticipants',
  ['fetchReportParticipantsAllData',]
)

// MOCK API REST --> this is a fake API for test front-end without back-end
export const mockMethods = mapActions('projects/mock', ['fetchAttendances'])

export const reportExcelMethods = mapActions(
  'reports/reports',
  ['fetchParticipantsExcel', 'fetchBudgetExcel', 'fetchParticipantsExcelTemplate', 'SubmitParticipantsExcel']
)
